/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-nested-ternary */
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-extra-boolean-cast */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { QuestionCircleOutlined } from '@ant-design/icons'
import {
  Button,
  Checkbox,
  Col,
  DatePicker,
  Flex,
  Form,
  FormInstance,
  InputNumber,
  Radio,
  Select,
  Spin,
  Table,
  Tooltip,
  Typography,
  notification,
} from 'antd/es'
import TextArea from 'antd/es/input/TextArea'
import dayjs, { Dayjs } from 'dayjs'
import {
  Dispatch,
  FC,
  PropsWithChildren,
  SetStateAction,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from 'react'
import { useTranslation } from 'react-i18next'
import { useQueryClient } from 'react-query'
import { useWatch } from 'antd/es/form/Form'

import { QUERY_KEYS } from '@api'
import { NoteElement, TicketFilesVariantDetail, TicketFilesVariantForm } from '@components'
import { ticketStatusToDisablePrimaryButtonforAdmin, TIME_OPTIONS_CONFIG } from '@constants'
import { useUser } from '@contexts'
import {
  useCarriers,
  useDestinations,
  useEquipment,
  useMaterials,
  usePurchaseOrdersByMaterial,
  useSuppliers,
} from '@hooks'
import {
  CarrierAvailabilitySummary,
  ComboOption,
  Equipment,
  EquipmentDataSummarized,
  Note,
  RoleEnum,
  SapItemSupplier,
  StatusTicketEnum,
  Supplier,
  Ticket,
  TicketAssignmentType,
  TripTypeEnum,
  DeclinedLoadTypeEnum,
} from '@types'
import { OtherUtils, StringUtils } from '@utils'

import { MaterialLabelContainer } from '.'
import { DATE_KEYS } from '../../../constants/dateKeys'
import { useGetCarriersAvailabilitySummary } from '../../../hooks/carrierAvailability/useGetCarriersAvailabilitySummary'
import { theme } from '../../../styles/theme'
import { mapDestinationsToCombo } from '../../../utils/array-entity-to-combo'
import { limitIntEntry, preventEvent } from '../../../utils/inputs'
import { CommentElement } from '../../CommentElement'
import { FlexCol, FlexRow, StyledLabels, StyledRow, StyledSpinner } from '../../StyledComponents'
import StatusTicket from './statusTicket'

const { Option } = Select

const rowCarrierClassSetter = (status: StatusTicketEnum) => `row-${status}_CARRIER`
const { trimText, classesToString } = StringUtils

const { ADMIN, SUPPLIER, ADMINRO } = RoleEnum
const { PURCHASES } = QUERY_KEYS

const { PENDING, CONFIRMED, CREATED, TRANSIT, DELIVERED } = StatusTicketEnum
const statusRefs = [PENDING, CONFIRMED]
const permittedAdminEditionStatus = [PENDING, CREATED]
const ticketOwnedByCarrierStatus = [TRANSIT, DELIVERED]
const declinedLoadEditionStatus = [CONFIRMED, TRANSIT, DELIVERED]

const initialValuesNewTicket = {
  count: 1,
  supplierId: undefined,
  depotId: undefined,
  materialId: undefined,
  equipmentId: undefined,
  destinationId: undefined,
  ticketsDate: dayjs(
    `${dayjs().add(1, 'd').format('DD-MM-YYYY')} ${dayjs().hour() + 1}:00:00`,
    DATE_KEYS.FORMAT.FULL_TIME,
  ).toDate(),
  carrierId: undefined,
  comments: undefined,
  approved: false,
  documentNumberId: undefined,
}

const handleFilterOptions = (input: string, option: any) => {
  if (option.label) return option.label.toString().toLowerCase().includes(input.toLowerCase())
  return true
}

const today = dayjs()
const tomorrow = today.clone().add(1, 'day').startOf('day')

interface TicketAux {
  count: number
  supplierId?: number | undefined
  depotId?: number | undefined
  materialId?: number | undefined
  equipmentId?: number | undefined
  destinationId?: number | undefined
  ticketDate?: Date | Date[] | undefined
  carrierId?: number | undefined
  comments?: string | undefined
  approved?: boolean
}

type Dates = Date[] | undefined

interface TicketFormProps {
  form: FormInstance<any>
  handlePrimaryButtonDisabling: (value: boolean) => void
  editable: boolean | undefined
  setEditable: Dispatch<SetStateAction<boolean | undefined>>
  dates: Dates
  setDates: Dispatch<SetStateAction<Dates>>
  roles: RoleEnum[]
  isWarning: boolean | undefined
  setIsWarning: Dispatch<SetStateAction<boolean | undefined>>
  ifToApproved: boolean | undefined
  assignValue: 'manual' | 'automatic' | undefined
  setAssignValue: Dispatch<SetStateAction<'manual' | 'automatic' | undefined>>
  carrierAvailabilityIsEnabled: boolean
  ticket?: Ticket
  maxAllowedDaysForSupplierRequest?: number
}

const TicketForm: FC<PropsWithChildren<TicketFormProps>> = ({
  handlePrimaryButtonDisabling,
  editable,
  setEditable,
  ticket,
  dates,
  setDates,
  roles,
  isWarning,
  setIsWarning,
  ifToApproved,
  form,
  assignValue,
  setAssignValue,
  carrierAvailabilityIsEnabled,
  maxAllowedDaysForSupplierRequest,
}) => {
  // hooks
  const { t } = useTranslation()
  const { state: user } = useUser()
  const queryClient = useQueryClient()
  const { allCarriersOptions } = useCarriers()
  const { equipments } = useEquipment()
  const { suppliersOptions, suppliers } = useSuppliers()

  // states
  const [plantId, setPlantId] = useState<string>()
  const [depots, setDepots] = useState<ComboOption[]>([])
  const [isCalendarVisible, setIsCalendarVisible] = useState<boolean>(false)
  const [beforeToday, setBeforeToday] = useState<boolean>()
  const [required, setRequired] = useState<boolean>(true)
  const [availableQuantity, setAvailableQuantity] = useState<string>()
  const [initialValuesAux, setInitialValuesAux] = useState<TicketAux>()
  const [initialDate, setInitialDate] = useState<Date[]>() // form dependency
  const [selectedCarrier, setSelectedCarrier] = useState<number>()
  const [selectedSupplier, setSelectedSupplier] = useState<Supplier>()
  const [showCarrierTable, setShowCarrierTable] = useState<boolean>()
  const [selectedPurchaseOrder, setSelectedPurchaseOrder] = useState<SapItemSupplier>()
  const [enableDocument, setEnableDocument] = useState<boolean>(false)
  const [selectedEquipmentId, setSelectedEquipmentId] = useState<number>()

  // hooks with dependencies
  const { purchaseOrders } = usePurchaseOrdersByMaterial(
    user?.userDetail.supplier?.sapId || selectedSupplier?.sapId,
  )
  const { materials, materialsOptions } = useMaterials()

  const destinationCodesFromPurchaseOrders = useMemo(
    () => [...new Set(purchaseOrders?.map(({ PlantID }) => PlantID))],
    [purchaseOrders],
  )
  const { allDestinationsOptions, destinations } = useDestinations(user?.userDetail.supplier?.sapId)
  const {
    carriersAvailabilitySummaryData,
    carriersAvailabilitySummaryDataIsLoading,
    refetchCarriersAvailabilitySummaryData,
  } = useGetCarriersAvailabilitySummary(
    dates ? dayjs(dates[0]).format(DATE_KEYS.FORMAT.ISO) : undefined,
  )

  const declinedLoadValue = useWatch('declinedLoad', form)

  const isRequiredMsg = t('globals.obligatory_field')

  const closeCalendar = () => {
    setIsCalendarVisible(false)
  }

  const resetFields = () => {
    setInitialValuesAux(setInitialValues())
    setTimeout(form.resetFields, 1)
  }

  const resetPurchaseOrders = () => {
    form.resetFields(['depotId', 'materialId', 'destinationId'])
    form.setFieldsValue({ documentNumberId: undefined, destinationId: undefined })
    setPlantId(undefined)
    setSelectedPurchaseOrder(undefined)
    setAvailableQuantity(undefined)
    queryClient.removeQueries([PURCHASES])
  }

  const handleSelectCarrier = (carrierId: number | undefined) => {
    form.setFieldsValue({ carrierId })
  }

  const handleSelectEquipment = (value?: number) => {
    setSelectedEquipmentId(value)
    if (initialValuesAux?.carrierId) {
      handlePrimaryButtonDisabling(!value)
    }
  }

  const materialLabel = useMemo(
    () =>
      materialsOptions?.find(material => material.value === ticket?.material.id)?.label ??
      `${ticket?.material.nameShort} ${ticket?.material.sapCode.replace(/^0+/, '')}`,
    [materialsOptions, ticket?.material.id],
  )

  const editByCarrierIsBlocked = useMemo(
    () => ticketOwnedByCarrierStatus.includes(ticket?.status.name as StatusTicketEnum),
    [ticket?.status.name],
  )

  const truckInfo = useMemo(
    () =>
      OtherUtils.joinArrayValuesOnText([
        ticket?.truck?.licensePlate,
        ticket?.truck?.description,
        ticket?.truck?.equipmentType?.nameShort,
      ]),
    [ticket],
  )

  const trailerInfo = useMemo(
    () =>
      OtherUtils.joinArrayValuesOnText([
        ticket?.trailer?.licensePlate,
        ticket?.trailer?.description,
        ticket?.trailer?.equipmentType?.nameShort,
      ]),
    [ticket],
  )

  const setInitialValues = useCallback(() => {
    if (ticket) {
      return {
        count: 1,
        supplierId: ticket?.supplier.id ?? undefined,
        depotId: ticket?.origin.id ?? undefined,
        materialId: ticket?.material.id ?? undefined,
        equipmentId: ticket?.equipment ? ticket?.equipment.id : undefined,
        destinationId: ticket?.destination ? ticket?.destination.id : undefined,
        carrierId: ticket?.carrier ? ticket.carrier.id : undefined,
        comments: ticket?.comments ?? undefined,
        number: ticket?.deliveryNote,
        autoAssignValue: assignValue,
        approved: ticket?.status.name !== CREATED,
        documentNumberId: ticket?.documentNumberId,
        withdrawalTime: ticket?.withdrawalDate,
        declinedLoad: !!ticket?.declinedLoadAt,
        declinedLoadType: ticket?.declinedLoadType,
      }
    }
    return initialValuesNewTicket
  }, [ticket, assignValue])

  const handleDestinationSelect = useCallback(
    (value: number) => {
      handlePrimaryButtonDisabling(true)
      setAvailableQuantity(undefined)
      form.setFieldsValue({ materialId: undefined })
      form.setFieldsValue({ documentNumberId: undefined })
      const destinationPlantId =
        destinations && destinations.find(destination => destination.id === value)
      const filteredPlantId = destinationPlantId?.plantId
      setPlantId(filteredPlantId)
    },
    [destinations],
  )

  const isDateAfterToday = useCallback(
    () => dates && dates[0].getTime() < dayjs().toDate().getTime(),
    [dates],
  )

  const isTomorrow = useMemo(
    () =>
      dates &&
      dayjs(dates[0]).startOf('day').toDate().getTime() ===
        dayjs().add(1, 'day').startOf('day').toDate().getTime(),
    [dates],
  )

  const setDefaultTicketTime = useCallback(
    (thisDates: Date[] | null) => {
      const datesAux = thisDates?.map(date => {
        return dayjs(date).startOf('d').toDate().getTime()
      })
      return roles?.includes(SUPPLIER) && datesAux?.includes(tomorrow.toDate().getTime())
        ? dayjs().hour() + 1 <= 12
          ? 12
          : 18
        : 12
    },
    [roles],
  )

  const calendarFooter = useCallback(
    () => (
      <FlexRow
        style={{
          justifyContent: 'end',
          padding: '0.5rem',
        }}
      >
        <Button type="primary" onClick={closeCalendar}>
          Aceptar
        </Button>
      </FlexRow>
    ),
    [roles],
  )

  const handleMaterialsOptions = useCallback(
    (value: number | undefined) => {
      form.setFieldsValue({ materialId: value })
      const selectedMaterial = materials?.find(material => material.id === value)
      setAvailableQuantity(selectedMaterial?.sapItemSupplier?.AvailableQuantity ?? '')
      handlePrimaryButtonDisabling(false)
    },
    [materials],
  )

  const handleTimeChange = useCallback(
    (value: string | undefined) => {
      form.setFieldsValue({ withdrawalTime: value })
      if (value) {
        const thisTime = dayjs(`2024-01-01T${value}:00`)
        dates?.forEach(date => {
          date.setHours(thisTime.hour())
          date.setMinutes(thisTime.minute())
          date.setSeconds(0)
        })
      }
      if (dates?.length && isDateAfterToday()) {
        setAssignValue('manual')
        setBeforeToday(true)
        if (roles.includes(SUPPLIER)) {
          handlePrimaryButtonDisabling(true)
        }
      } else {
        setBeforeToday(false)
      }
    },
    [
      dates,
      form,
      roles,
      SUPPLIER,
      isDateAfterToday,
      setAssignValue,
      setBeforeToday,
      handlePrimaryButtonDisabling,
    ],
  )

  const handleChangeDate = useCallback(
    (thisDates?: Dayjs[]) => {
      form.resetFields(['withdrawalTime'])
      const datesAux = thisDates?.map(d => d.startOf('d').toDate().getTime())
      if (roles?.includes(SUPPLIER)) {
        if (datesAux?.includes(tomorrow.toDate().getTime())) {
          notification.warning({
            message: 'Atención: no podrá solicitar servicios con menos de 24 hs de anticipación',
            duration: 5,
            key: 'date24hs',
          })
        }
      }
      setDates(thisDates?.map(d => d.toDate()).sort((a, b) => (a < b ? -1 : 1)))
    },
    [roles],
  )

  const handleSupplierOptions = useCallback(
    (value: number | undefined) => {
      resetPurchaseOrders()
      if (value) {
        form.resetFields(['depotId', 'materialId', 'destinationId'])
        form.setFieldsValue({
          documentNumberId: undefined,
          destinationId: undefined,
          materialId: undefined,
        })
        setPlantId(undefined)
        const supplierAux = suppliers?.find(supplier => supplier.id === value)
        setSelectedSupplier(supplierAux)
        const depotsAux = supplierAux?.depots.map(depot => ({
          label: depot.tag,
          value: depot.id,
        }))
        setDepots(depotsAux || [])
        setEnableDocument(!!supplierAux?.sapId)
      }
    },
    [suppliers],
  )

  const handlePurchaseDocumentChange = (documentNumberId: string | undefined) => {
    setSelectedPurchaseOrder(
      purchaseOrders?.find(purchaseOrder => purchaseOrder.DocumentNumberID === documentNumberId),
    )
    form.setFieldsValue({ documentNumberId })
    handlePrimaryButtonDisabling(true)
  }

  const isOptionDisabled = (value: number) =>
    roles.includes(SUPPLIER) && isTomorrow && value <= dayjs().hour()

  useEffect(() => {
    if (roles?.includes(SUPPLIER)) {
      setShowCarrierTable(false)
    } else if (!ticket || beforeToday !== undefined) {
      setShowCarrierTable(
        !!ticket && !beforeToday && !!carrierAvailabilityIsEnabled && !editByCarrierIsBlocked,
      )
    } else {
      setShowCarrierTable(false)
    }
  }, [beforeToday, ticket, carrierAvailabilityIsEnabled, editByCarrierIsBlocked])

  useEffect(() => {
    // Set the state of initialDate when ticket is already loaded
    if (ticket?.withdrawalDate) {
      setInitialDate([dayjs(ticket.withdrawalDate).toDate()])
    } else {
      setInitialDate(undefined)
    }
  }, [ticket])

  useEffect(() => {
    if (initialDate && !dates) {
      setDates(initialDate)
    }
  }, [initialDate])

  useEffect(() => {
    if (!initialValuesAux && ticket && assignValue) {
      setInitialValuesAux(setInitialValues())
    }
  }, [ticket, assignValue])

  useEffect(() => {
    if (ticket) {
      setSelectedEquipmentId(ticket.equipment.id)
      if (!window.location.pathname.includes('/evouchers')) {
        setRequired(true)
      } else setRequired(false)
      handleSupplierOptions(ticket?.supplier.id)
      if (ticket && ticket?.destination) {
        setPlantId(ticket?.destination.plantId || undefined)
      }
      const withdrawalDate = dayjs(ticket?.withdrawalDate)
      const twentyFourHsFromNow = today.clone()
      twentyFourHsFromNow.add(1, 'd')

      if (
        roles?.includes(SUPPLIER) &&
        ticket?.status.name === CREATED &&
        !(withdrawalDate < twentyFourHsFromNow)
      ) {
        setEditable(true)
        handlePrimaryButtonDisabling(false)
        if (ticket.supplier.sapId) setEnableDocument(true)
      } else {
        setEditable(false)
        handlePrimaryButtonDisabling(true)
        setEnableDocument(false)
      }

      if (
        !!(
          roles?.includes(ADMIN) &&
          permittedAdminEditionStatus.includes(ticket?.status.name as StatusTicketEnum) &&
          withdrawalDate > dayjs()
        )
      ) {
        setEditable(true)
      }
      if ([DELIVERED].includes(ticket?.status.name as StatusTicketEnum)) {
        setEditable(false)
        setEnableDocument(false)
      }

      if (
        roles?.includes(ADMIN) &&
        ![DELIVERED].includes(ticket?.status.name as StatusTicketEnum)
      ) {
        setEnableDocument(ticket.tripType === TripTypeEnum.FOB)
        handlePrimaryButtonDisabling(false)
      }

      if (!roles?.includes(SUPPLIER)) {
        setSelectedCarrier(ticket?.carrier?.id)
      }
    } else {
      setSelectedEquipmentId(undefined)
      setPlantId(undefined)
      setDepots([])
      setRequired(true)
      setEditable(true)
      setEnableDocument(!!user?.userDetail.supplier?.sapId)
    }
    setInitialValuesAux(setInitialValues())

    resetFields()
  }, [ticket])

  useEffect(() => {
    if (!roles?.includes(SUPPLIER)) {
      if (selectedCarrier) {
        const selectedCarrierElement = document.querySelector(
          '.ant-table-row-selected',
        ) as HTMLElement
        if (selectedCarrierElement) {
          selectedCarrierElement.scrollIntoView({ behavior: 'smooth', block: 'center' })
        }
      }
      handleSelectCarrier(selectedCarrier)
    }
  }, [selectedCarrier])

  useEffect(() => {
    if (ticket && roles.includes(ADMIN)) {
      if (assignValue === 'automatic') {
        setSelectedCarrier(undefined)
      }
    }
  }, [assignValue])

  useEffect(() => {
    if (!!dates?.length) {
      refetchCarriersAvailabilitySummaryData()
      setIsWarning(false)
      handleTimeChange(
        ticket?.withdrawalDate
          ? dayjs(ticket?.withdrawalDate).format('HH:mm')
          : roles.includes(SUPPLIER)
          ? dayjs().startOf('day').set('hours', setDefaultTicketTime(dates)).format('HH:mm')
          : undefined,
      )
    }
  }, [dates])

  useEffect(() => {
    if (roles?.includes(SUPPLIER)) {
      setSelectedSupplier(user?.userDetail.supplier)
    }
  }, [])

  useEffect(() => {
    if (selectedPurchaseOrder) {
      form.setFieldsValue({ materialId: undefined })
    }
  }, [selectedPurchaseOrder])

  return showCarrierTable !== undefined ? (
    <Form form={form} initialValues={initialValuesAux} name="ticket-form" className="ticket-form">
      <FlexCol className="ticket-form__column ticket-data">
        {!!(ticket && !editable && ticket.status.name) && (
          <StatusTicket status={ticket.status.name}>
            {(ticket.status.name === 'CONFIRMED' || ticket.status.name === 'TRANSIT') && (
              <Tooltip
                title={t(
                  'notifications.the_trip_will_be_delivered_when_the_sap_ticket_is_validated.',
                )}
              >
                <QuestionCircleOutlined style={{ marginLeft: '17rem' }} />
              </Tooltip>
            )}
          </StatusTicket>
        )}
        <FlexCol className="form-section">
          {ticket && !editable && (
            <StyledRow className="form-detail-title">
              <span>{`${t('Detalle ID')} #${ticket?.id}`}</span>
            </StyledRow>
          )}
          {!ticket && (
            <StyledRow className="new-ticket-form-row">
              <Form.Item
                label={t('suppliers_router.new_ticket_modal.quantity')}
                rules={[
                  {
                    required: true,
                    message: isRequiredMsg,
                  },
                ]}
                name="count"
              >
                <InputNumber onPaste={preventEvent} onKeyDown={limitIntEntry} min={1} max={10} />
              </Form.Item>
            </StyledRow>
          )}
          {!roles?.includes(SUPPLIER) && (
            <StyledRow className="new-ticket-form-row">
              <Form.Item
                label="Proveedor"
                rules={[
                  {
                    required,
                    message: isRequiredMsg,
                  },
                ]}
                name="supplierId"
              >
                <Select
                  allowClear
                  showSearch
                  disabled={!!ticket || roles?.includes(ADMINRO)}
                  getPopupContainer={(triggerNode: HTMLElement) =>
                    triggerNode.parentNode as HTMLElement
                  }
                  placeholder={t('globals.placeholder_select')}
                  options={suppliersOptions}
                  onChange={handleSupplierOptions}
                  filterOption={handleFilterOptions}
                />
              </Form.Item>
            </StyledRow>
          )}
          <StyledRow className="new-ticket-form-row">
            <Form.Item
              label="Origen"
              rules={[
                {
                  required,
                  message: isRequiredMsg,
                },
              ]}
              name="depotId"
            >
              <Select
                showSearch
                filterOption={handleFilterOptions}
                disabled={ticket && !editable}
                getPopupContainer={(triggerNode: HTMLElement) =>
                  triggerNode.parentNode as HTMLElement
                }
                placeholder={t('globals.placeholder_select')}
                options={
                  roles?.includes(ADMIN) || roles?.includes(ADMINRO)
                    ? depots
                    : user?.userDetail.supplier?.depots.map(depot => ({
                        label: depot.tag,
                        value: depot.id,
                      }))
                }
              />
            </Form.Item>
          </StyledRow>
          <StyledRow className="new-ticket-form-row">
            <Form.Item
              label="Destino"
              rules={[
                {
                  required,
                  message: isRequiredMsg,
                },
              ]}
              name="destinationId"
            >
              <Select
                showSearch
                filterOption={handleFilterOptions}
                allowClear
                disabled={ticket && !editable}
                getPopupContainer={(triggerNode: HTMLElement) =>
                  triggerNode.parentNode as HTMLElement
                }
                placeholder={t('globals.placeholder_select')}
                options={
                  !!selectedSupplier?.sapId
                    ? mapDestinationsToCombo(
                        destinations?.filter(destination =>
                          destinationCodesFromPurchaseOrders.includes(destination.plantId),
                        ),
                      )
                    : allDestinationsOptions
                }
                onChange={handleDestinationSelect}
              />
            </Form.Item>
          </StyledRow>
          <StyledRow className="new-ticket-form-row">
            <Form.Item
              label="Orden de compra"
              name="documentNumberId"
              rules={[
                {
                  required: enableDocument,
                  message: isRequiredMsg,
                },
              ]}
            >
              {ticket?.sapItemSupplier?.disabledAt ? (
                <div>
                  <span>{`${ticket.sapItemSupplier.DocumentNumberID} - ${OtherUtils.capitalize(
                    dayjs(ticket.sapItemSupplier.ProposedDeliveryDate)
                      .format('MMM-YY')
                      .replace('.', ''),
                  )} - ${ticket.sapItemSupplier.Inco1}/${ticket.sapItemSupplier.Inco2}`}</span>
                </div>
              ) : (
                <Select
                  showSearch
                  filterOption={handleFilterOptions}
                  disabled={!enableDocument || !plantId}
                  getPopupContainer={(triggerNode: HTMLElement) =>
                    triggerNode.parentNode as HTMLElement
                  }
                  placeholder={!!selectedSupplier?.sapId && t('globals.placeholder_select')}
                  options={
                    purchaseOrders
                      ? purchaseOrders
                          ?.filter(
                            ({ disabledAt, DocumentNumberID, PlantID }) =>
                              (!disabledAt || DocumentNumberID === ticket?.documentNumberId) &&
                              PlantID === plantId,
                          )
                          .map(purchaseDocument => ({
                            label: `${purchaseDocument.DocumentNumberID} - ${OtherUtils.capitalize(
                              dayjs(purchaseDocument.ProposedDeliveryDate)
                                .format('MMM-YY')
                                .replace('.', ''),
                            )} - ${purchaseDocument.Inco1}/${purchaseDocument.Inco2}`,
                            value: purchaseDocument.DocumentNumberID,
                          }))
                      : undefined
                  }
                  onChange={handlePurchaseDocumentChange}
                />
              )}
            </Form.Item>
          </StyledRow>
          <StyledRow className="new-ticket-form-row">
            <Form.Item
              label="Material"
              name="materialId"
              rules={[
                {
                  required,
                  message: isRequiredMsg,
                },
                {
                  validator: () => {
                    if (ticket?.status.name === 'DELIVERED') {
                      return Promise.reject(
                        notification.info({
                          message: t('tpl_dashboard.delivered_error'),
                          key: 'materialError',
                        }),
                      )
                    }
                    return Promise.resolve()
                  },
                },
              ]}
            >
              {ticket?.sapItemSupplier?.disabledAt && !!ticket ? (
                <MaterialLabelContainer>
                  <span>{materialLabel}</span>
                  {selectedPurchaseOrder?.DocumentNumberID !== undefined && (
                    <div>
                      {!!availableQuantity &&
                        `${t(
                          'suppliers_router.new_ticket_modal.available',
                        )} ${availableQuantity} kg`}
                      {` (${t('suppliers_router.new_ticket_modal.available')} ${
                        selectedPurchaseOrder?.AvailableQuantity ?? ''
                      } kg)`}
                    </div>
                  )}
                </MaterialLabelContainer>
              ) : (
                <Select
                  showSearch
                  onChange={handleMaterialsOptions}
                  filterOption={handleFilterOptions}
                  getPopupContainer={(triggerNode: HTMLElement) =>
                    triggerNode.parentNode as HTMLElement
                  }
                  placeholder={t('globals.placeholder_select')}
                  options={materialsOptions}
                  disabled={ticket?.status?.name === 'DELIVERED'}
                />
              )}
            </Form.Item>
          </StyledRow>
          <StyledRow className="new-ticket-form-row">
            <Form.Item
              label="Equipo"
              rules={[
                {
                  required: (!!roles?.includes(ADMIN) || !!roles?.includes(SUPPLIER)) && required,
                  message: isRequiredMsg,
                },
              ]}
              name="equipmentId"
            >
              <Select
                showSearch
                filterOption={handleFilterOptions}
                allowClear
                disabled={ticket && !editable}
                getPopupContainer={(triggerNode: HTMLElement) =>
                  triggerNode.parentNode as HTMLElement
                }
                placeholder={t('globals.placeholder_select')}
                options={equipments?.map(equipment => ({
                  label: equipment.nameShort,
                  value: equipment.id,
                }))}
                onChange={handleSelectEquipment}
              />
            </Form.Item>
          </StyledRow>
          <StyledRow className="new-ticket-form-row">
            <Form.Item
              label={
                <>
                  {required && <div className="required-asterisk">*</div>}
                  <span>Fecha</span>
                </>
              }
              rules={[
                {
                  required,
                  message: isRequiredMsg,
                },
              ]}
            >
              <FlexCol className="ticket-form__dates-column">
                <FlexRow>
                  {ticket && !editable ? (
                    <DatePicker
                      className="ticket-form__date-picker-viewer"
                      disabled
                      showTime={{ format: DATE_KEYS.FORMAT.TIME }}
                      format={DATE_KEYS.FORMAT.DAY_SHORT}
                      value={dayjs(ticket?.withdrawalDate)}
                    />
                  ) : (
                    <DatePicker
                      multiple={!ticket}
                      onChange={date =>
                        handleChangeDate((!ticket ? date : [date]) as unknown as Dayjs[])
                      }
                      open={isCalendarVisible}
                      renderExtraFooter={calendarFooter}
                      onClick={() => {
                        setIsCalendarVisible(true)
                      }}
                      value={
                        !ticket
                          ? dates?.map(date => dayjs(date))
                          : dates?.length
                          ? dayjs(dates[0])
                          : undefined
                      }
                      maxTagCount="responsive"
                      required
                      format={DATE_KEYS.FORMAT.DAY_SHORT}
                      className={classesToString([
                        'ticket-form__date-picker-input',
                        isWarning && 'ticket-form__is-warning',
                      ])}
                      disabled={ticket && !editable}
                      inputReadOnly
                      minDate={roles?.includes(SUPPLIER) ? tomorrow : undefined}
                      maxDate={
                        roles?.includes(SUPPLIER) && maxAllowedDaysForSupplierRequest
                          ? dayjs().add(maxAllowedDaysForSupplierRequest, 'day')
                          : undefined
                      }
                    />
                  )}
                </FlexRow>
                <FlexRow>
                  {!!dates?.length
                    ? `${t('suppliers_router.new_ticket_modal.dates_quantity')} ${dates?.length}`
                    : ''}
                </FlexRow>
              </FlexCol>
            </Form.Item>
          </StyledRow>
          <Form.Item
            name="withdrawalTime"
            label={t('globals.limit_hour')}
            rules={[
              {
                required: true,
                message: t('globals.seleted_hour_please'),
              },
            ]}
          >
            <Select
              className={classesToString([
                'ticket-form__time-picker-input',
                isWarning && 'ticket-form__is-warning',
              ])}
              disabled={(ticket && !editable) || !dates?.length}
              onChange={handleTimeChange}
              placeholder={t('globals.limit_hour')}
            >
              {TIME_OPTIONS_CONFIG.map(option => (
                <Option
                  key={option.value}
                  value={option.value}
                  disabled={isOptionDisabled(option.intValue)}
                >
                  {`${option.value} ${t(option.labelKey)}`}
                </Option>
              ))}
            </Select>
          </Form.Item>
          {!showCarrierTable &&
            (roles?.includes(ADMIN) || roles?.includes(ADMINRO)) &&
            ((!ticket && assignValue === 'manual') ||
              ticket?.ticketAssignments.length ||
              (ticket?.status.name === CREATED && assignValue === 'manual')) && (
              <StyledRow className="new-ticket-form-row">
                <Form.Item
                  rules={[
                    {
                      required: !ticket || (ticket?.status.name as StatusTicketEnum) === CREATED,
                      message: isRequiredMsg,
                    },
                  ]}
                  label="Transportista"
                  name="carrierId"
                >
                  <Select
                    disabled={
                      (roles?.includes(ADMINRO) ||
                        ![PENDING, CONFIRMED, CREATED].includes(
                          ticket?.status?.name as StatusTicketEnum,
                        )) &&
                      !!ticket
                    }
                    onChange={(value: number) => {
                      setSelectedCarrier(value)
                    }}
                    getPopupContainer={(triggerNode: HTMLElement) =>
                      triggerNode.parentNode as HTMLElement
                    }
                    placeholder={t('globals.placeholder_select')}
                    showSearch
                    filterOption={handleFilterOptions}
                    options={allCarriersOptions?.map(option => ({
                      label: option.label || 'N/A',
                      value: option.value,
                    }))}
                    allowClear
                  />
                </Form.Item>
              </StyledRow>
            )}
          {roles?.includes(ADMIN) &&
            ((!!ifToApproved && ticket?.ticketAssignments.length === 0) || !ticket) && (
              <StyledRow className="new-ticket-form-row" id="radio-button">
                <Form.Item label="Asignación" name="autoAssignValue">
                  <FlexRow className="ticket-form__assign-radio-group">
                    {['automatic', 'manual'].map(assignation => {
                      const disabled = assignation === 'automatic' ? beforeToday : undefined
                      return (
                        <FlexRow className="ticket-form__assign-radio-input">
                          <Radio
                            value={assignation}
                            disabled={disabled}
                            onChange={() => setAssignValue(assignation as 'automatic' | 'manual')}
                            checked={assignValue === assignation}
                          />
                          <StyledLabels>{t(`globals.generics.${assignation}`)}</StyledLabels>
                        </FlexRow>
                      )
                    })}
                  </FlexRow>
                </Form.Item>
              </StyledRow>
            )}
          {ticket?.id && ticket?.id > 0 && (
            <StyledRow className="new-ticket-form-row">
              <Form.Item label={t('ticket_modal.created_at')} name="createAt">
                <span className="ticket-field-value">
                  {dayjs(ticket?.createAt).format(DATE_KEYS.FORMAT.FULL_TIME)}
                </span>
              </Form.Item>
            </StyledRow>
          )}
          {ticket ? (
            <StyledRow className="new-ticket-form-row">
              <Form.Item label={t('ticket_modal.driver')} name="driver">
                <div>
                  {ticket.driver ? (
                    <span className="ticket-field-value">
                      {`${ticket.driver?.stateIdNumber} - 
                      ${ticket.driver?.firstName} ${ticket.driver?.lastName}`}
                    </span>
                  ) : (
                    <span className="ticket-field-value-error">N/A</span>
                  )}
                </div>
              </Form.Item>
            </StyledRow>
          ) : null}
          {ticket ? (
            <StyledRow className="new-ticket-form-row">
              <Form.Item label={t('ticket_modal.truck')} name="truck">
                <div>
                  {ticket.truck ? (
                    <span title={truckInfo} className="ticket-field-value">
                      {trimText(truckInfo, 50)}
                    </span>
                  ) : (
                    <span className="ticket-field-value-error">N/A</span>
                  )}
                </div>
              </Form.Item>
            </StyledRow>
          ) : null}
          {ticket ? (
            <StyledRow className="new-ticket-form-row">
              <Form.Item label={t('ticket_modal.trailer')} name="trailer">
                <div>
                  {ticket?.trailer && trailerInfo ? (
                    <span title={trailerInfo} className="ticket-field-value">
                      {trimText(trailerInfo, 50)}
                    </span>
                  ) : (
                    <span className="ticket-field-value-error">N/A</span>
                  )}
                </div>
              </Form.Item>
            </StyledRow>
          ) : null}
          {ticket && declinedLoadEditionStatus.includes(ticket.status.name as StatusTicketEnum) ? (
            <StyledRow
              className="new-ticket-form-row"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
              }}
            >
              <Form.Item label={t('ticket_modal.load_rejected')} name="declinedLoad">
                {roles.includes(ADMIN) &&
                declinedLoadEditionStatus.includes(ticket.status.name as StatusTicketEnum) ? (
                  <Checkbox
                    onChange={({ target }) => {
                      form.setFieldValue('declinedLoad', target.checked)
                      handlePrimaryButtonDisabling(false)
                    }}
                    checked={declinedLoadValue}
                  />
                ) : ticket.declinedLoadAt ? (
                  <span className="ticket-field-value">
                    {dayjs(ticket.declinedLoadAt).format(DATE_KEYS.FORMAT.FULL_TIME)}
                  </span>
                ) : (
                  <span className="ticket-field-value-error">N/A</span>
                )}
              </Form.Item>
            </StyledRow>
          ) : null}
          {ticket &&
          declinedLoadValue &&
          declinedLoadEditionStatus.includes(ticket.status.name as StatusTicketEnum) ? (
            <StyledRow className="new-ticket-form-row">
              <Form.Item
                rules={[
                  {
                    required: true,
                    message: isRequiredMsg,
                  },
                ]}
                label={t('ticket_modal.reason_for_rejection')}
                name="declinedLoadType"
              >
                {roles.includes(ADMIN) ? (
                  <Select
                    onChange={(value: number) => {
                      form.setFieldValue('declinedLoadType', value)
                      handlePrimaryButtonDisabling(false)
                    }}
                    getPopupContainer={(triggerNode: HTMLElement) =>
                      triggerNode.parentNode as HTMLElement
                    }
                    placeholder={t('globals.placeholder_select')}
                    showSearch
                    filterOption={handleFilterOptions}
                    options={Object.values(DeclinedLoadTypeEnum)?.map(item => ({
                      label: t(`ticket_modal.${item.toLowerCase()}`),
                      value: item,
                    }))}
                    allowClear
                  />
                ) : ticket.declinedLoadType ? (
                  <span className="ticket-field-value">
                    {t(`ticket_modal.${ticket.declinedLoadType.toLowerCase()}`)}
                  </span>
                ) : (
                  <span className="ticket-field-value-error">N/A</span>
                )}
              </Form.Item>
            </StyledRow>
          ) : null}
          {ticket?.ticketSap && (
            <StyledRow className="new-ticket-form-row">
              <Form.Item label={t('tpl_router.tpl_dashboard.ticketSap')} name="ticketSap">
                <div>
                  <span title={ticket?.ticketSap} className="ticket-field-value">
                    {ticket?.ticketSap}
                  </span>
                </div>
              </Form.Item>
            </StyledRow>
          )}
          {ticket?.deliveryNote && (
            <StyledRow className="new-ticket-form-row">
              <Form.Item label={t('tpl_router.tpl_dashboard.delivery_note')} name="number">
                <div>
                  <span title={ticket?.deliveryNote} className="ticket-field-value">
                    {ticket?.deliveryNote}
                  </span>
                </div>
              </Form.Item>
            </StyledRow>
          )}
        </FlexCol>
        {(!ticket || editable) && (
          <FlexCol className="form-section">
            <StyledRow className="new-ticket-form-row comments">
              <Form.Item label={t('ticket_modal.comments')} name="comments">
                <TextArea maxLength={1200} rows={3} allowClear />
              </Form.Item>
            </StyledRow>
          </FlexCol>
        )}
        {!!ticket && (
          <FlexCol className="form-section flex-1">
            {!editable ? <TicketFilesVariantDetail /> : <TicketFilesVariantForm />}
          </FlexCol>
        )}
        <FlexCol className="form-section form-comments flex-1">
          <StyledRow className="section-header">
            <Col
              className={
                ticket && !editable ? 'form-comments__non-editable' : 'form-comments__editable'
              }
              span={ticket && !editable ? 8 : undefined}
            >
              {' '}
              {!!ticket && (
                <p className={classesToString(['form-comments__p', ticket && !editable && 'bold'])}>
                  {t('ticket_modal.comment')}
                </p>
              )}
            </Col>
            <Col span={ticket && !editable ? 24 : 16}>
              {ticket?.observations?.map((observation: Note) =>
                ticket && !editable ? (
                  <CommentElement data={observation} />
                ) : (
                  <NoteElement data={observation} />
                ),
              )}
            </Col>
          </StyledRow>
        </FlexCol>
      </FlexCol>
      {showCarrierTable && (
        <FlexCol className="ticket-form__column carrier-selection">
          {carriersAvailabilitySummaryDataIsLoading ||
          !carriersAvailabilitySummaryData ||
          !equipments ? (
            <StyledSpinner />
          ) : (
            <>
              <FlexRow className="carrier-table-status-header">
                <Form.Item
                  rules={[
                    {
                      required:
                        (ticket?.status.name as StatusTicketEnum) === CREATED &&
                        assignValue === 'manual',
                      message: isRequiredMsg,
                    },
                  ]}
                  label={t('carrier_availability.ticket_modal.table_subtitle')}
                  name="carrierId"
                />
                <Tooltip
                  className="carrier-table-status__tooltip-refs"
                  color="white"
                  getPopupContainer={(triggerNode: HTMLElement) =>
                    triggerNode.parentNode as HTMLElement
                  }
                  placement="leftTop"
                  title={
                    <FlexCol className="carrier-table-status__tooltip-refs__title">
                      {statusRefs.map((status, index) => (
                        <FlexRow
                          key={status + '-' + index}
                          className="carrier-table-status__tooltip-refs__status-row"
                        >
                          <div
                            style={{
                              backgroundColor: (
                                theme.carrierTableColors as { [key: string]: string }
                              )[status],
                            }}
                            className="carrier-table-status-ref-sample"
                          />
                          <Typography className="carrier-table-status__tooltip-refs__status-row__description">
                            {t(`carrier_availability.ticket_modal.refs.${status}`)}
                          </Typography>
                        </FlexRow>
                      ))}
                    </FlexCol>
                  }
                >
                  <QuestionCircleOutlined className="refs-icon-info" />
                </Tooltip>
              </FlexRow>
              <Table
                scroll={{ y: '100%', x: '100%' }}
                className={classesToString([
                  'carrier-selection-table',
                  assignValue === 'automatic' &&
                    ticket?.status.name === CREATED &&
                    'disabled-input-opacity',
                ])}
                rowKey={({ carrier }) => carrier.id}
                sortDirections={['ascend', 'descend']}
                showSorterTooltip
                rowClassName={record => {
                  const ticketAssignmentStatuses = ticket?.ticketAssignments
                    .filter((item: TicketAssignmentType) => item.carrier.id === record.carrier.id)
                    .sort((a, b) => (a.id < b.id ? 1 : 0))
                  if (
                    !!ticketAssignmentStatuses?.length &&
                    ticketAssignmentStatuses[0].status.name === ticket?.status.name
                  ) {
                    return rowCarrierClassSetter(
                      ticketAssignmentStatuses[0].status.name as unknown as StatusTicketEnum,
                    )
                  }
                  return ''
                }}
                columns={[
                  {
                    title: t('carrier_availability.ticket_modal.name_column_header') as string,
                    dataIndex: 'carrier',
                    width: '11rem',
                    sorter: (a, b) => {
                      if (a.carrier.tradeName < b.carrier.tradeName) {
                        return -1
                      }
                      if (a.carrier.tradeName > b.carrier.tradeName) {
                        return 1
                      }
                      return 0
                    },
                    defaultSortOrder: 'ascend',
                    render: ({ tradeName }) => tradeName,
                  },
                  ...equipments
                    .filter(({ highDemand }) => !!highDemand)
                    .map(({ nameShort, id: equipmentId }) => ({
                      key: equipmentId,
                      title: () => (
                        <Flex
                          className={`carrier-column-header${
                            equipmentId === selectedEquipmentId
                              ? ' column-SELECTED_EQUIPMENT_COLUMN'
                              : ''
                          }`}
                        >
                          {nameShort}
                        </Flex>
                      ),
                      dataIndex: 'equipmentDataSummarized',
                      sorter: (a: CarrierAvailabilitySummary, b: CarrierAvailabilitySummary) =>
                        a.equipmentDataSummarized.find(
                          ({ equipment }: { equipment: Equipment }) => equipment.id === equipmentId,
                        )!.available -
                        b.equipmentDataSummarized.find(
                          ({ equipment }: { equipment: Equipment }) => equipment.id === equipmentId,
                        )!.available,
                      renderHeader: 'asd',
                      render: (equipmentDataSumarized: EquipmentDataSummarized[]) => (
                        <Flex
                          style={{
                            backgroundColor:
                              equipmentId === selectedEquipmentId
                                ? theme.carrierTableColors.SELECTED_EQUIPMENT_COLUMN
                                : '',
                            height: '100%',
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <Typography.Text className="carrier-table-status-equipment-header">
                            {equipmentDataSumarized.find(
                              ({ equipment }: { equipment: Equipment }) =>
                                equipment.id === equipmentId,
                            )?.available ?? '-'}
                          </Typography.Text>
                        </Flex>
                      ),
                    })),
                ]}
                rowSelection={{
                  onChange: selectedRowKeys => {
                    if (roles?.includes(ADMIN)) {
                      setSelectedCarrier(selectedRowKeys[0] as unknown as number)
                    }
                  },
                  selectedRowKeys: selectedCarrier ? [selectedCarrier] : undefined,
                  type: 'radio',
                  renderCell:
                    roles?.includes(ADMINRO) ||
                    (assignValue === 'automatic' && ticket?.status.name === CREATED) ||
                    ticketStatusToDisablePrimaryButtonforAdmin.includes(
                      ticket?.status.name as StatusTicketEnum,
                    )
                      ? () => <div />
                      : undefined,
                }}
                dataSource={carriersAvailabilitySummaryData}
                pagination={false}
              />
            </>
          )}
        </FlexCol>
      )}
    </Form>
  ) : (
    <FlexRow className="ticket-modal-spin-container">
      <Spin className="ticket-modal-spinner" size="large" />
    </FlexRow>
  )
}

export default TicketForm
